import { forwardRef, type ComponentProps } from 'react';
import type { WebTarget } from 'styled-components';

import ErrorBoundary from '../ErrorBoundary';

import { CardRoot } from './Card.styled';

type Props = ComponentProps<typeof CardRoot> & { as?: WebTarget };

const Card = forwardRef<HTMLElement, Props>((props, ref) => {
  const { children, ...rest } = props;

  return (
    <CardRoot ref={ref} {...rest}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </CardRoot>
  );
});

Card.displayName = 'Card';

export default Card;
